export const INVESTOR_TYPES = {
  "Conservative Investor": {
    series: "Stability", range: "12% – 16%", riskAppetite: "Lower / Conservative",
    plans: { "6 Months": "Alpha Secure", "12 Months": "Capital Shield", "Long-Term": "Stable Income" },
  },
  "Balanced Investor": {
    series: "Growth", range: "15% – 20%", riskAppetite: "Moderate / Balanced",
    plans: { "6 Months": "Balanced Alpha", "12 Months": "Core Growth", "Long-Term": "Dynamic Wealth" },
  },
  "Experienced Investor": {
    series: "Prestige", range: "18% – 24%", riskAppetite: "Higher / Experienced",
    plans: { "6 Months": "Aggressive Alpha", "12 Months": "Prime Momentum", "Long-Term": "Absolute Return" },
  },
};

export const INVESTOR_TYPE_NAMES = Object.keys(INVESTOR_TYPES);

export const TENURE_OPTIONS = ["6 Months", "12 Months", "Long-Term"];

export const WITHDRAWAL_OPTIONS = ["Monthly", "Quarterly", "Annually", "At Redemption"];

export const RANGE_DISCLAIMER = "Target / illustrative range configured by KMC Solutions — not a guaranteed or assured return.";
